import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { IonicModule } from '@ionic/angular';

import { ModalService } from './../../services/utils/modal/modal.service';

@Component({
  selector: 'app-privacy-police',
  templateUrl: './privacy-police.component.html',
  styleUrls: ['./privacy-police.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule],
})
export class PrivacyPoliceComponent implements OnInit {
  public url!: string;
  public safeUrl!: SafeResourceUrl;

  constructor(
    public modalService: ModalService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }
}
